import React from 'react';
import cn from 'clsx';
import {utilityClassesGenerator} from '../util/styles';
import TextParser from './TextParser';
import styles from './Typography.module.scss';

const Typography = (props) => {
    const {
        className,
        style,
        text,
        as = 'p',
        onClick
    } = props;

    if (text === undefined || text === null || text === '') {
        return null;
    }

    const Tag = `${as}`;

    return (
        <Tag className={cn(className, styles.typography, {
            ...utilityClassesGenerator(props),
        })} onClick={onClick} style={style}>
            <TextParser text={text}/>
        </Tag>
    )
};

export default Typography;
